@if (this.clientData?.result$ | async; as result) {
    @if (result.value?.data; as clientData) {
        @if (result.isLoading) {
            <cll-spinner />
        }

        @if (result.error; as error) {
            <app-error-panel [error]="error" />
        }
        <div class="accordion-container">
            <cll-card-divider />
            <div class="accordion-map">
                <google-map [options]="options" (mapInitialized)="initMap($event, clientData)" width="100%" #map>
                    @if (clientData.person.address.lat && clientData.person.address.lng) {
                        <map-advanced-marker #markerElem="mapAdvancedMarker" [title]="clientData.person.address.post_code"
                                            [position]="{ lat: +clientData.person.address.lat, lng: +clientData.person.address.lng }" />
                    }
                </google-map>
            </div>
            <div class="accordion-row-field">
                <app-accordion-item [label]="'Address line 1'" [data]="clientData.person.address.street_1"/>
            </div>
            <div class="accordion-row-field">
                <app-accordion-item [label]="'Address line 2'" [data]="clientData.person.address.street_2"/>
            </div>
            <div class="accordion-row-field">
                <app-accordion-item [label]="'Town'" [data]="clientData.person.address.town"/>
            </div>
            <div class="accordion-row-field">
                <app-accordion-item [label]="'County'" [data]="clientData.person.address.county"/>
            </div>
            <div class="accordion-row-field">
                <app-accordion-item [label]="'Country'" [data]="clientData.person.address.country"/>
            </div>
            <div class="accordion-row-field">
                <app-accordion-item [label]="'Postcode'" [data]="clientData.person.address.post_code"/>
            </div>
            <div class="accordion-row-field">
                <app-accordion-item [label]="'Address additional comments'" [data]="clientData.person.address.additional_comments"/>
            </div>

            <div class="accordion-row-field">
                <app-accordion-item [label]="'Is the property hard to reach'" [data]="clientData.person.address.hard_to_reach ? 'Yes' : 'No'"/>
            </div>
            <div class="accordion-row-field">
                <app-accordion-item [label]="'Email address'" [data]="clientData.email"/>
            </div>
            @if (clientData.contact_numbers; as contactNumbers) {
                @if (contactNumbers.length > 0) {
                    @for (contactNumber of contactNumbers; track contactNumber.id) {
                        <div class="accordion-row-field">
                            <app-accordion-item [label]="contactNumber.type" [data]="contactNumber.number"/>
                        </div>
                    }
                }
            }
            <cll-card-footer>
                <button cll-tonal-button (click)="editContactAddressDetails()">
                    <cll-icon cllButtonIcon type="outlined" [size]="20">edit</cll-icon>
                    Edit
                </button>
            </cll-card-footer>
        </div>
    }
}
